/**
 * App.js
 *
 * FIX: Added /setup-password route for the password invitation flow.
 * FIX: Catch-all now renders a proper 404 page instead of redirecting to AuthContainer.
 */
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";

import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute    from "./components/ProtectedRoute";

// Public pages
import AuthContainer     from "./pages/AuthContainer";
import PasswordSetup     from "./pages/PasswordSetup";
import NotFound          from "./pages/NotFound";
import ForgotPassword    from "./pages/ForgotPassword";
import ResetPassword     from "./pages/ResetPassword";
// Protected pages
import DashBoard         from "./components/DashBoard";
import DashboardHome     from "./components/DashboardHome";
import TenantManagement  from "./pages/TenantManagement";
import UserManagement    from "./components/UserManagement";
import LocationHierarchy from "./components/LocationHierarchy";
import OrganizationHierarchy from "./components/OrganizationHierarchy";
import AssetManagement   from "./components/AssetManagement";
import IoTControllers    from "./pages/IoTControllers";
import AssetIoTDataMonitoring from "./pages/AssetIoTDataMonitoring";
import Reports                from "./pages/Reports";
import AnalyticsDashboard     from "./pages/AnalyticsDashboard";
import { SensorDataProvider } from "./context/SensorDataContext";

export default function App() {
  return (
    <Router>
      <AuthProvider>
        <SensorDataProvider>
        <Toaster position="top-right" />
        <Routes>

          {/* ── Public routes ─────────────────────────────────────── */}
          <Route path="/"               element={<AuthContainer />} />

          {/* NEW: Password setup page — linked from invitation email */}
          <Route path="/setup-password" element={<PasswordSetup />} />
          <Route path="/forgot-password" element={<ForgotPassword/>}/>
          <Route path="/reset-password" element={<ResetPassword/>} /> 

          {/* ── Protected routes ──────────────────────────────────── */}
          <Route element={<ProtectedRoute />}>
            <Route path="/tenants"            element={<TenantManagement />} />
            <Route element={<DashBoard />}>
              <Route path="/dashboard"          element={<DashboardHome />} />
              <Route path="/users"              element={<UserManagement />} />
              <Route path="/locations"          element={<LocationHierarchy />} />
              <Route path="/organizations"      element={<OrganizationHierarchy />} />
              <Route path="/assets"             element={<AssetManagement />} />
              <Route path="/iot-controllers"    element={<IoTControllers/>}/>

              <Route path="/advanced-dashboard"  element={<AnalyticsDashboard />} />
              <Route path="/data-monitoring"     element={<AssetIoTDataMonitoring />} />
              <Route path="/reports"             element={<Reports />} />
            </Route>
          </Route>

          
          <Route path="*" element={<NotFound />} />

        </Routes>
        </SensorDataProvider>
      </AuthProvider>
    </Router>
  );
}